module.exports = __webpack_public_path__ + "img/summary-3.87eac6c3.svg";